export class Cards {
    constructor(
        public topicCard=[],
        public statusUpdate=[])
    { }
  }




